import React, { memo, useState } from 'react';
import { Switch } from '@dls/react-core';
import { Typography } from '@material-ui/core';
import { GraphProps, SingleGraph, YAxisSettings } from './graph-single';
import { computeDomain, groupByKey } from './graph-utils';

export const Graph: React.FC<GraphProps> = memo(({ data: unmappedData, ...props }) => {
  const [syncDomains, setSyncDomains] = useState(true);
  const data = unmappedData && mapAxisValues(props.settings.yAxes, unmappedData);

  if (!props.settings.groupBy || !data?.length) {
    return <SingleGraph {...props} data={data} />;
  }

  const grouped: Record<string, GraphProps['data']> = groupByKey(data, props.settings.groupBy);

  const yAxes = syncDomains
    ? props.settings.yAxes.map((yAxis) => ({
        ...yAxis,
        domainStart:
          yAxis.domainStart === undefined && data
            ? computeDomain('start', data as any, props.zoomRange, yAxis.dataKeys)
            : yAxis.domainStart,
        domainEnd:
          yAxis.domainEnd === undefined && data
            ? computeDomain('end', data as any, props.zoomRange, yAxis.dataKeys)
            : yAxis.domainEnd,
      }))
    : props.settings.yAxes;

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'end',
          alignItems: 'center',
          gap: 8,
          paddingBottom: 16,
          marginTop: -34,
        }}
      >
        <Typography>Sync domains</Typography>
        <Switch checked={syncDomains} onChange={(e) => setSyncDomains(e.target.checked)} />
      </div>
      {Object.entries(grouped).map(([k, v], idx, entries) => {
        const isLast = idx === entries.length - 1;
        return (
          <SingleGraph
            {...props}
            data={v}
            settings={{
              ...props.settings,
              xAxis: {
                ...props.settings.xAxis,
                hide: !isLast,
              },
              yAxes,
              description: props.settings.groupBy + ': ' + k,
              grid: {
                top: 10,
                left: 140,
                bottom: isLast ? 32 : 0,
              },
            }}
          />
        );
      })}
    </>
  );
});

function mapAxisValues(
  yAxes: YAxisSettings[],
  data: Record<string, any>[],
): NonNullable<GraphProps['data']> {
  let mappedData = [...data];
  for (const yAxis of yAxes) {
    if (!yAxis.mapValue) continue;

    for (const dataKey of yAxis.dataKeys) {
      mappedData = mappedData.map((d, idx) => ({
        ...d,
        [dataKey]: yAxis.mapValue!(d[dataKey], idx, data),
      }));
    }
    // data?.map((d, idx) => [d[xAxis.dataKey], yAxis.mapValue!(d[dataKey], idx, data)])
  }
  return mappedData;
}
